import { ChangeDetectionStrategy, Component } from '@angular/core';

import { WhyFinderBase } from '@player/shared/directives/why-finder-base';
import { AsyncPipe } from '@angular/common';
import { BasicModule } from '@shared/modules/basic.module';
import { MatIcon } from '@angular/material/icon';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';

@Component({
  selector: 'why-finder',
  templateUrl: './why-finder.component.html',
  styleUrls: ['./why-finder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatIcon, BasicModule, SharedModuleForPlayer],
})
export class WhyFinder extends WhyFinderBase {}
